const cohortKeys = {
  CUMULATIVE: '__CUMULATIVE__',
  NULL: '__NULL__',
  OTHER: '(Other)',
};
export default cohortKeys;
